let pendingAddSheetAuthorizations = 0;

/** Gate 通過後または免除経路でのみ ADD_SHEET を許可する */
export function authorizeNextAddSheet(): void {
  pendingAddSheetAuthorizations += 1;
}

export function consumeAddSheetAuthorization(): boolean {
  if (pendingAddSheetAuthorizations > 0) {
    pendingAddSheetAuthorizations -= 1;
    return true;
  }
  return false;
}
